<template>
  <page-header />
  <a-card title="订单详情">
    <!-- 基本信息 -->
    <a-descriptions title="订单信息" bordered>
      <a-descriptions-item label="订单号">{{ orderInfo.order_no }}</a-descriptions-item>
      <a-descriptions-item label="总价">¥{{ orderInfo.total_price }}</a-descriptions-item>
      <a-descriptions-item label="状态">{{ orderInfo.state }}</a-descriptions-item>
      <a-descriptions-item label="创建时间">{{ orderInfo.created_at }}</a-descriptions-item>
    </a-descriptions>

    <!-- 商品信息 -->
    <a-table
        :dataSource="orderInfo.order_products"
        :columns="productColumns"
        :pagination="false"
        style="margin-top: 20px"
        bordered
    >
      <template #title><h3>商品信息</h3></template>
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'productName'">
          {{ record.product.name }}
        </template>
        <template v-if="column.dataIndex === 'price'">
          ¥{{ record.price }}
        </template>
      </template>
    </a-table>

    <!-- 支付信息 -->
    <a-descriptions title="支付信息" bordered style="margin-top: 20px">
      <a-descriptions-item label="支付方式">{{ orderInfo.trade?.provider_type }}</a-descriptions-item>
      <a-descriptions-item label="支付金额">¥{{ orderInfo.trade?.price }}</a-descriptions-item>
      <a-descriptions-item label="支付时间">{{ orderInfo.trade?.pay_time }}</a-descriptions-item>
      <a-descriptions-item label="交易号">{{ orderInfo.trade?.trade_no }}</a-descriptions-item>
    </a-descriptions>

    <!-- 操作日志 -->
    <a-table
        :dataSource="orderInfo.order_logs"
        :columns="logColumns"
        :pagination="false"
        style="margin-top: 20px"
        bordered
    >
      <template #title><h3>订单日志</h3></template>
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'create_time'">
          {{ record.create_time }}
        </template>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import {defineComponent, onMounted, ref} from 'vue'
import {message} from 'ant-design-vue'
import request from '@/utils/request'
import {useRoute} from 'vue-router'
import PageHeader from "@/components/header.vue";

export default defineComponent({
  name: 'OrderDetail',
  components: {PageHeader},
  setup() {
    const route = useRoute()
    const orderId = route.query.id
    const orderInfo = ref({
      order_products: [],
      order_logs: [],
      trade: {}
    })

    // 商品信息列配置
    const productColumns = [
      {
        title: '商品名称',
        dataIndex: 'productName',
        width: '30%'
      },
      {
        title: '单价',
        dataIndex: 'price',
        width: '15%'
      },
      {
        title: '数量',
        dataIndex: 'quantity',
        width: '15%'
      }
    ]

    // 操作日志列配置
    const logColumns = [
      {
        title: '操作',
        dataIndex: 'action',
        width: '30%'
      },
      {
        title: '操作时间',
        dataIndex: 'create_time',
        width: '40%'
      }
    ]

    // 获取订单详情
    const fetchOrderDetail = async () => {
      try {
        const res = await request.get(`/order/detail/${orderId}`)
        orderInfo.value = res.data
      } catch (error) {
        message.error('获取订单详情失败')
      }
    }

    // 初始化
    onMounted(() => {
      fetchOrderDetail()
    })

    return {
      orderInfo,
      productColumns,
      logColumns
    }
  }
})
</script>

<style scoped>
.ant-descriptions {
  margin-bottom: 20px;
}
</style>
